import { useBoolean } from "ahooks";
import { useContext, useEffect, useState } from "react";
import { Tag, message, Button, Input } from "antd";
import { ColumnsType } from "antd/lib/table";
import { ConfirmModal } from "../../../../component/modal";
import { Mask } from "../../../../component/mask";
import { ButtonPanel } from "../../../../component/button-panel/button_panel";
import { defualtPageSize, Progress } from "../../../../logic/common_logic";
import { AuthLogic } from "../../../../logic/auth_logic";
import { Control, See, Edit, Del } from "../../../../component/control-column";
import { DataTableStore } from "../../../../component/table/store/data_table_store";
import { fileAction } from "../../action/shiftchange/file_action";
import { FileStore } from "../../store/shiftChange/file_store";
import { DataTable } from "../../../../component/table/view/data_table";
import { Search } from "../../../../component/search";
import { Tips, TipsGroup } from "../../../../component/tips";
import { FileSearch } from "../shiftChanges/file_search";
import { FormStoreProvider } from "../../store/shiftChange/form_store";
import { Form } from "./form";
import { FormAction } from "../../action/shiftchange/form_action";

const formParams = {
  id: "",
  method: "",
  item: Object,
};
export function File(viewPower) {
  const [createState, createFunc] = useBoolean(false);
  const [confirmState, confirmFunc] = useBoolean(false);
  const [searchState, searchFunc] = useBoolean(false);
  const action = fileAction;

  const { state, dispatch } = useContext(FileStore);
  const { state: tableState, dispatch: tableDispatch } =
    useContext(DataTableStore);
  const formAction = new FormAction();
  const [menuButton, setData] = useState([]);
  useEffect(() => {
    (async function () {
      let r = await new AuthLogic().selButton(viewPower.viewPower);
      if (r && r.length > 0) {
        for (let i = 0; i < r.length; i++) {
          r[i] = r[i].split("_")[r[i].split("_").length - 1];
        }
      }
      setData(r);
    })();

    return () => {};
  }, []);
  const columns: ColumnsType = [
    {
      title: "操作",
      // dataIndex: 'id',
      key: "1",
      align: "center",
      width: Control.width(2),
      render: Control.render(
        (v) =>
          menuButton.indexOf("VIEW") != -1 && (
            <See
              click={() => {
                formParams.id = v.id;
                formParams.method = "Preview";
                formParams.item = v;
                createFunc.setTrue();
              }}
            />
          )
        // v => menuButton.indexOf("UPDATE") != -1 && <Edit click={() => {
        //     formParams.id = v.id;
        //     formParams.method = "Edit";
        //     createFunc.setTrue();
        // }} />,
        // v => menuButton.indexOf("DELETE") != -1 && <Del click={() => {
        //     formParams.id = v.id;
        //     confirmFunc.setTrue();
        // }} />
      ),
    },
    {
      title: "交班人",
      dataIndex: "userName",
      key: "2",
      align: "center",
      width: 140,
    },
    {
      title: "总营业额",
      dataIndex: "turnover",
      key: "3",
      align: "center",
    },
    {
      title: "总营业单数",
      dataIndex: "orderCount",
      key: "4",
      align: "center",
      width: 100,
    },
    {
      title: "备用金",
      dataIndex: "reserves",
      key: "5",
      align: "center",
    },
    {
      title: "总销售额",
      dataIndex: "sales",
      key: "6",
      align: "center",
    },
    {
      title: "会员充值总金额",
      dataIndex: "memberRecharge",
      key: "7",
      align: "center",
      width: 100,
    },
    {
      title: "交班起止时间",
      key: "8",
      align: "center",
      render: (v) => (
        <span>
          {v.beginTime}~{v.endTime}
        </span>
      ),
    },
  ];

  const onSearch = async (pageIndex) => {
    await action.loadPage({
      pageIndex: pageIndex,
      pageSize: defualtPageSize(),
      dispatch: tableDispatch,
      search: state.search,
    });
  };
  return (
    <div>
      <Search>
        <Input
          allowClear
          maxLength={20}
          placeholder="请输入交班人名称"
          onChange={(e) =>
            action.setCondition("Keywords", e.target.value, dispatch)
          }
        />
        <input type="button" value="快速查找" onClick={() => onSearch(1)} />

        <TipsGroup>
          <input
            type="button"
            value="高级查找"
            onClick={() => searchFunc.toggle()}
          />
          <Tips width="45rem" display={searchState}>
            <FileSearch
              onSearch={(...arg: [any]) => {
                onSearch(...arg);
                searchFunc.setFalse();
              }}
            />
          </Tips>
          <Mask visible={searchState} onClick={() => searchFunc.setFalse()} />
        </TipsGroup>
      </Search>
      <ButtonPanel>
        {menuButton.indexOf("ADD") != -1 && (
          <Button
            onClick={() => {
              formParams.id = "";
              formParams.method = "Create";
              createFunc.setTrue();
            }}
          >
            补班
          </Button>
        )}
      </ButtonPanel>
      <DataTable
        action={action}
        columns={columns}
        onLoad={() => {
          Progress.done();
          onSearch(1);
        }}
        onChange={(pageIndex) => onSearch(pageIndex)}
        loading={tableState.loading}
      />

      {createState && (
        <FormStoreProvider>
          <Form
            close={async (hasUpdate) => {
              if (hasUpdate) {
                await onSearch(tableState.current);
              }

              createFunc.setFalse();
            }}
            action={formAction}
            item={formParams.item}
            id={formParams.id}
            method={formParams.method}
          />
        </FormStoreProvider>
      )}
    </div>
  );
}
